import React from "react";
import { Link } from "react-router-dom";

import { isSpecial, modelOf, viewerIcon, buttonTarget } from "../../services/viewers";

import GroupButton from "./GroupButton";

import BackButton from "./BackButton";

import ViewerStyle from '../../css/Viewer.module.css';

// The viewers of one model: its special viewers first, then its months.
// With many months the specials would sit at the bottom of a long list, so
// two or more go behind one button, "Datos Canales Modelo N", which opens
// them with a "Regresar" as every group of the menu does (the owner's
// decision of 2026-10-13); a single one keeps its own button. The parent
// owns `open`, because an open group takes the whole menu.
export default function ModelViewers(props) {
    const { viewers, open, onToggle, handleButtonClick, activeMenuButton, dataViewers } = props;

    // One button per viewer that is not a Personas one: a Personas viewer is
    // reached through its counterpart's tabs, and a special viewer may have no
    // population at all.
    const buttons = viewers.filter(viewer => viewer.population !== 'people');
    const specials = buttons.filter(isSpecial);
    const months = buttons.filter(viewer => !isSpecial(viewer));

    const button = (viewer) => {
        const target = buttonTarget(viewer, dataViewers);
        const label = viewer.label.replace(" Hogares", "");
        return (
            <Link key={viewer.id}
                to={`/visor-rpd/${target.slug}`}
                title={label}
                className={`${ViewerStyle["btn-month"]}${activeMenuButton === viewer.id ? ` ${ViewerStyle["active"]}` : ''}`}
                onClick={() => handleButtonClick(viewer.id, dataViewers.indexOf(target))}>
                <ion-icon name={viewerIcon(viewer)}></ion-icon>
                <span>{label}</span>
            </Link>
        );
    };

    if (open) {
        return (
            <>
                <BackButton onClick={onToggle} />
                {specials.map(button)}
            </>
        );
    }

    const holdsActive = specials.some(viewer => viewer.id === activeMenuButton);
    return (
        <>
            {specials.length === 1 ? button(specials[0]) : null}
            {specials.length > 1 ? (
                <GroupButton label={`Datos Canales Modelo ${modelOf(specials[0])}`} count={specials.length} onClick={onToggle} active={holdsActive} icon="stats-chart-outline" />
            ) : null}
            {months.map(button)}
        </>
    );
}
